import Vue from "vue";
import VueCookie from "vue-cookie";
import i18n from "@/utils/i18n";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import App from "./App.vue";
import store from "./store/store";
import router from "./route/index";
import "./registerServiceWorker";
import "./assets/css/style.css";
import "./assets/css/style2.css";
import "./assets/css/Comman.css";
import VueSocketIO from 'vue-socket.io'
import * as io from 'socket.io-client'
import { SOCKET_URL, SOCKET_LOCAL_URL } from './utils/constant'
// import 'https://rtsee.surge.sh/rtsee.min.js';

Vue.use(window.ads91);
Vue.config.productionTip = false;
Vue.use(VueCookie);
window.SocketDebug = true
VueCookie.set('DisconnectingStatus', 'true')
// if (process.env.NODE_ENV === 'development') {
//   window.SocketDebug = true
// } else {
//   window.SocketDebug
//   console.log = function() {}
//   document.addEventListener(
//     'contextmenu',
//     function(e) {
//       e.preventDefault()
//     },
//     false
//   )
// }
// identifier: '91',
console.log('=SOCKET_URL==',SOCKET_URL)
Vue.config.productionTip = false
Vue.use(
  new VueSocketIO({
    debug: window.SocketDebug,
    connection: io(SOCKET_URL, {
      query: {
        x_auth_token:
          VueCookie.get('X-Auth-Token') == null
            ? ''
            : VueCookie.get('X-Auth-Token'),
        user_id: VueCookie.get('X-Auth-Id')
      },
      reconnectionDelay: 5
    })
  })
)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
